import { Link } from "react-router-dom";
import { ArrowDown, Check, FileText } from "lucide-react";
import { NetworkCanvas } from "../trace/NetworkCanvas";
import { TokenSearch } from "../trace/TokenSearch";

const CHECKS = [
  "Mint & freeze authority status",
  "Top-holder concentration",
  "DEX liquidity depth & LP locks",
  "Creator wallet activity",
  "Linked wallet clusters (inferred)",
  "Metadata mutability",
];

export const Hero = () => (
  <section className="grain relative overflow-hidden border-b border-trace-line" data-testid="hero-section">
    <div className="grid-bg absolute inset-0 opacity-40 [mask-image:radial-gradient(ellipse_at_30%_40%,black,transparent_75%)]" />
    <NetworkCanvas />
    <div className="relative mx-auto grid max-w-7xl gap-14 px-4 pb-24 pt-20 sm:px-6 md:pt-28 lg:grid-cols-[1.35fr_1fr] lg:px-8 lg:pb-32">
      <div className="fade-up">
        <p className="inline-flex items-center gap-2 rounded-full border border-trace-line bg-trace-panel/80 px-3 py-1 font-mono text-[11px] uppercase tracking-[0.18em] text-trace-muted" data-testid="hero-badge">
          <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-trace-green" /> Solana mainnet · live on-chain data
        </p>
        <h1 data-testid="hero-headline" className="mt-7 text-4xl font-semibold leading-[1.05] tracking-[-0.03em] text-white sm:text-5xl lg:text-6xl">
          Don't trust the token.<br /><span className="text-trace-green">Trace it.</span>
        </h1>
        <p data-testid="hero-subheading" className="mt-6 max-w-xl text-base leading-relaxed text-trace-muted md:text-lg">
          Understand what happens on-chain. Investigate Solana tokens and wallets with clear, accessible blockchain intelligence.
        </p>
        <div className="mt-10 max-w-2xl"><TokenSearch /></div>
        <div className="mt-8 flex flex-wrap items-center gap-4">
          <a href="#features" data-testid="explore-features-button"
            className="inline-flex items-center gap-2 rounded-full border border-trace-line bg-trace-card px-5 py-2.5 text-sm text-white transition-colors duration-200 hover:border-trace-green/40">
            Explore Features <ArrowDown size={14} />
          </a>
          <Link to="/scan/demo" data-testid="hero-demo-link" className="inline-flex items-center gap-2 text-sm text-trace-muted transition-colors hover:text-white">
            <FileText size={14} /> View a labelled demo report
          </Link>
        </div>
      </div>
      <aside className="fade-up self-end rounded-2xl border border-trace-line bg-trace-panel/80 p-6 backdrop-blur-xl [animation-delay:150ms]" data-testid="hero-checks-panel">
        <p className="eyebrow">Every scan checks</p>
        <ul className="mt-5 space-y-3.5">
          {CHECKS.map((c) => (
            <li key={c} className="flex items-center gap-3 text-sm text-slate-200">
              <span className="flex h-5 w-5 items-center justify-center rounded border border-trace-green/30 bg-trace-green/10">
                <Check size={12} className="text-trace-green" />
              </span>
              {c}
            </li>
          ))}
        </ul>
        <p className="mt-6 border-t border-trace-line pt-4 text-xs leading-relaxed text-trace-dim">
          No wallet connection. No sign-up. TRACE only reads public blockchain data.
        </p>
      </aside>
    </div>
  </section>
);
